import { IFile } from './file.dto';
import { UserRole } from './crm-user';

export interface IContact {
  name?: string;
  email?: string;
  phone?: string;
}

export interface MessageDTO {
  channel: string;
  customerId: string;
  contact?: IContact;
  subject?: string;
  content: string;
  file?: IFile | string;
  requestFileName?: string;
}

export interface InboundDTO {
  channel: 'EMAIL' | 'SMS' | 'WEB';
  from?: string;
  subject?: string;
  text?: string;
  file?: IFile | string;
}

export class Message {
  _id: string;
  inbound: boolean;
  channel: string;
  customer?: string | Object;
  contact: IContact;
  subject?: string;
  content: string;
  adminUserName?: string;
  file?: string;
  template: { name: string; data: Object };
  status: 'pending' | 'delivered' | 'read';
  createdAt?: Date;
  readAt?: Date;
  deliveredAt?: Date;
  contextId?: string;
}

export interface IMessage extends Message {}

export enum ChannelType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  WHATSAPP = 'WHATSAPP',
  WEB = 'WEB'
}

export interface IAttachment {
  customerId: string;
  name: string;
  data: string;
}

export class CannedMessage {
  _id: string;
  scopeType: IMessageScope;
  scopeKey: string;
  name: string;
  content: string;
  language: ILanguages;
  roles?: UserRole[];
  category?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export class CannedMessageCategory {
  _id: string;
  organization?: string;
  name: string;
  createdAt?: Date;
  updatedAt?: Date;
}

//change all individual to user
export type IMessageScope = 'user' | 'group' | 'organization';

export type ILanguages = 'en' | 'fr';

export class CannedMessageQuery {
  _id?: string;
  scopeType: IMessageScope | 'all';
  scopeKey?: string;
  name?: string;
  language?: ILanguages;
  category?: string;
  // Sent as a query param; serialized to a CSV string in transit.
  roles?: UserRole[];
}
